export default __webpack_public_path__ + "static/6-c863297aec5fa87f3410e844ed9c70f0.png";